export const buildQueryString = (param: string | null) => param ? JSON.stringify((JSON.parse(param) || []).map((i: any) => i.value)) : ``;